import React from "react";
import { ShieldCheck, Clock, HelpCircle } from "lucide-react";

const MAP = {
  verified: { label: "VERIFIED", cls: "bg-emerald-950/85 text-emerald-400 border-emerald-500/40", Icon: ShieldCheck },
  documents_pending: { label: "DOCUMENTS PENDING", cls: "bg-amber-950/85 text-amber-400 border-amber-500/40", Icon: Clock },
  unverified: { label: "UNVERIFIED", cls: "bg-rose-950/85 text-rose-400 border-rose-500/40", Icon: HelpCircle },
};

export function VerificationBadge({ status, className = "", testid }) {
  const cfg = MAP[status] || MAP.unverified;
  const { Icon } = cfg;
  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-[10px] font-bold tracking-wider border backdrop-blur-md ${cfg.cls} ${className}`}
    >
      <Icon className="w-3 h-3" />
      {cfg.label}
    </span>
  );
}

const STATUS_MAP = {
  reviewed: { label: "Reviewed by professional", dot: "bg-emerald-500", text: "text-emerald-400" },
  review_pending: { label: "Document uploaded — review pending", dot: "bg-amber-500", text: "text-amber-400" },
  not_provided: { label: "Not provided", dot: "bg-slate-600", text: "text-slate-500" },
};

export function DocStatusRow({ category, status, testid }) {
  const cfg = STATUS_MAP[status] || STATUS_MAP.not_provided;
  return (
    <div data-testid={testid} className="flex items-center justify-between py-3 border-b border-white/5">
      <span className="text-sm text-slate-200">{category}</span>
      <span className={`inline-flex items-center gap-2 text-xs font-medium ${cfg.text}`}>
        <span className={`w-2 h-2 rounded-full ${cfg.dot}`} />
        {cfg.label}
      </span>
    </div>
  );
}
